import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@Component({
    selector: 'app-quoterequest-save-preset',
    templateUrl: './quoterequest-save-preset.component.html',
    standalone: false,
})
export class QuoteRequestSavePresetComponent implements OnInit {
    @Output() action = new EventEmitter();

    // @ts-ignore TS2564
    savePresetsParams: () => { presets; type };
    // @ts-ignore TS7008
    presets;
    // @ts-ignore TS7008
    type;
    // @ts-ignore TS7008
    quotePresetDescription;
    presetDescriptions: string[] = [];

    constructor(private bsModalRef: BsModalRef) {}

    ngOnInit() {
        this.presets = this.savePresetsParams().presets;
        this.type = this.savePresetsParams().type;
        this.presetDescriptions = this.presets
            // @ts-ignore TS7006
            .map((preset) => {
                return preset.Description;
            })
            .sort();
    }

    ok() {
        this.action.emit({ cancelled: false, presetDescription: this.quotePresetDescription });
        this.bsModalRef.hide();
    }

    cancel() {
        this.action.emit({ cancelled: true });
        this.bsModalRef.hide();
    }
}
@NgModule({
    imports: [CommonModule, FormsModule, TypeaheadModule],
    declarations: [QuoteRequestSavePresetComponent],
    exports: [QuoteRequestSavePresetComponent],
})
export class QuoteRequestSavePresetModule {}
